import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import ImagesSelector from "@/lib/components/form/file/auto-storing/ImageSelector.vue";
import SubMenu from "@/lib/components/layout/menu/SubMenu.vue";
import {PropType} from "vue";
import ButtonGroup from "@/lib/components/UI/ButtonGroup.vue";
import JsonSelector from "@/lib/components/form/file/auto-storing/JsonSelector.vue";
import {SAnnotatableImageData} from "@/store/Spatial2DAnnotation/model/SAnnotatableImageData";
import {
  AnnotatableImagesStoreManager
} from "@/store/Spatial2DAnnotation/manager/AnnotatableImagesStoreManager";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'CowImagesAnnotationLeftMenu',
  props: {
  annotatableImages: Array as PropType<SAnnotatableImageData[]>,
},
  setup(__props) {




// ------------------------------
//  Actions
// ------------------------------

const spawnBoundingBox = () =>
{
  AnnotatableImagesStoreManager.spawnEmptyBoundingBox();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SubMenu, {
      title: "Load mammals",
      icon: require('@/lib/assets/img/icons/chevron-right.svg')
    }, {
      default: _withCtx(() => [
        _createVNode(ImagesSelector, {
          text: "Load pictures",
          icon: require('@/lib/assets/img/icons/images.svg'),
          is_multiple: true,
          manager_class: _unref(AnnotatableImagesStoreManager),
          manager_mutator: "addEmpty"
        }, null, 8, ["icon", "manager_class"]),
        _hoisted_1,
        _withDirectives(_createVNode(JsonSelector, {
          text: "Load annotations data",
          icon: require('@/lib/assets/img/icons/graph.svg'),
          is_multiple: true,
          manager_class: _unref(AnnotatableImagesStoreManager),
          manager_mutator: "addFromFile",
          empty_store_before_load: false
        }, null, 8, ["icon", "manager_class"]), [
          [_vShow, __props.annotatableImages && __props.annotatableImages.length]
        ])
      ]),
      _: 1
    }, 8, ["icon"]),
    _withDirectives(_createVNode(SubMenu, {
      title: "Annotation tools",
      icon: require('@/lib/assets/img/icons/chevron-right.svg')
    }, {
      default: _withCtx(() => [
        _createVNode(ButtonGroup, {
          buttons: [{
          id: 'new-bounding-box',
          text: 'Add bounding box',
          icon: require('@/lib/assets/img/icons/box-add.svg'),
          additionalClass: 'button-style-bordered button-large'
        }],
          onClick: spawnBoundingBox
        }, null, 8, ["buttons"])
      ]),
      _: 1
    }, 8, ["icon"]), [
      [_vShow, __props.annotatableImages && __props.annotatableImages.length && _unref(AnnotatableImagesStoreManager).store.currentAnnotatableImage]
    ])
  ], 64))
}
}

})